import React, { useRef, useState } from 'react';
import { ImageCanvasRotation } from './image-canvas-rotation';
export const ImageZoom = ({ src, enableZoom = true, zoomSize, width, height, degrees, imageDimensions, onImageLoaded }) => {
    const SCALE_CANVAS_IMAGE = 3;
    const currentContainer = useRef(null);
    const [newImgUrl, setNewImgUrl] = useState('');
    const [currentSize, setCurrentSize] = useState({ width, height });
    const toZoomSize = enableZoom ? zoomSize : 1;
    const onCanvasLoadHandle = (src64) => {
        resizeImageAfterLoad();
        setNewImgUrl(src64);
    };
    const resizeImageAfterLoad = () => {
        const isLateralRotation = 
        // eslint-disable-next-line unicorn/prefer-includes-over-repeated-comparisons
        degrees === 90 || degrees === -90 || degrees === 270 || degrees === -270;
        if (isLateralRotation) {
            const resize = resizeVerticalPosition(width, height);
            setCurrentSize({
                width: resize.height,
                height: resize.width
            });
        }
        else {
            setCurrentSize({
                width,
                height
            });
        }
    };
    const resizeVerticalPosition = (newWidth, newHeight) => {
        if (currentContainer.current) {
            const wHeight = currentContainer.current.clientHeight || 0;
            if (wHeight >= newWidth)
                return { height: newHeight, width: newWidth };
            const percentReduce = wHeight / newWidth - 0.1;
            return {
                height: newHeight * percentReduce,
                width: newWidth * percentReduce
            };
        }
        return { height: newHeight, width: newWidth };
    };
    const largeSizeWidth = currentSize.width * toZoomSize;
    const largeSizeHeight = currentSize.height * toZoomSize;
    let canvasWidth = largeSizeWidth * toZoomSize * SCALE_CANVAS_IMAGE;
    let canvasHeight = largeSizeHeight * toZoomSize * SCALE_CANVAS_IMAGE;
    canvasWidth =
        imageDimensions.width && canvasWidth > imageDimensions.width
            ? imageDimensions.width
            : canvasWidth;
    canvasHeight =
        imageDimensions.height && canvasHeight > imageDimensions.height
            ? imageDimensions.height
            : canvasHeight;
    return (React.createElement("div", { className: "image__zoom", ref: currentContainer },
        newImgUrl && (React.createElement("div", { className: "image-zoom-content" },
            React.createElement("img", { alt: "zoomable image", height: enableZoom ? currentSize.height : height, onLoad: onImageLoaded, src: enableZoom ? newImgUrl : src, width: enableZoom ? currentSize.width : width }))),
        React.createElement(ImageCanvasRotation, { imageHeight: canvasHeight, imageWidth: canvasWidth, isVisible: false, onCanvasLoaded: onCanvasLoadHandle, rotate: degrees, src: src })));
};
